import { useLocation } from "react-router-dom"; 
import seoConfig from "../seoConfig";
import usePageSEO from "../Hooks/usePageSEO";

const SEOUpdater = () => {
  const location = useLocation();
  const seo = seoConfig[location.pathname];

  const title = seo?.title || "Rotiey - Fresh Food Delivered";
  const description = seo?.description || "Order delicious food online with Rotiey. Fresh, fast, and tasty.";
  const keywords = seo?.keywords || ["Rotiey", "food delivery", "online order"];

  usePageSEO(title, description, keywords);

  return null; // no UI
};

export default SEOUpdater;
